import { palette } from '@livable/saas-react-components';
const MuiDataGrid = {
  styleOverrides: {
    root: {
      border: 'none',
      boxShadow: palette.shadows.light,
      backgroundColor: palette.shades[100],
      borderRadius: '2px',
      fontSize: '15px',
      lineHeight: '19px',
      '& .indicators': {
        display: 'inline-block'
      },
      '& .MuiDataGrid-columnHeader': {
        padding: '10px 5px'
      },
      '& .MuiDataGrid-columnHeaderDraggableContainer': {
        borderRadius: '2px',
        transition: "background-color ".concat(palette.transitions.short),
        height: '100%'
      },
      '& .MuiDataGrid-columnHeaderTitleContainerContent': {
        overflow: 'hidden',
        whiteSpace: 'break-spaces',
        padding: '5px 10px',
        '& .inline-arrow .MuiSvgIcon-root': {
          width: '16px',
          height: '16px',
          '& path': {
            fill: palette.shades[700]
          }
        },
        '& .inline-filter': {
          display: 'none',
          '& .MuiSvgIcon-root': {
            width: '16px',
            height: '16px',
            marginLeft: '2px',
            '& path': {
              fill: palette.shades[700]
            }
          }
        }
      }
    },
    panelContent: {
      padding: '0 24px',
      maxHeight: '500px'
    },
    panelFooter: {
      padding: '18px 24px 24px 24px',
      display: 'block',
      '& .MuiButton-root': {
        padding: '10px 16px',
        fontSize: '13px',
        lineHeight: '16px',
        '& + .MuiButton-root': {
          marginLeft: '10px'
        }
      }
    },
    columnsPanelRow: {
      padding: '6px 0px 6px 0px'
    },
    columnsPanel: {
      padding: '0 2px'
    },
    panelHeader: {
      padding: '24px 24px 18px 24px'
    },
    paper: {
      boxShadow: palette.shadows.mid,
      marginTop: '10px',
      maxHeight: '600px'
    },
    filterForm: {
      padding: '24px 0'
    },
    filterFormDeleteIcon: {
      justifyContent: 'center',
      marginRight: '10px'
    },
    filterFormColumnInput: {
      marginRight: '10px',
      width: '180px'
    },
    filterFormOperatorInput: {
      marginRight: '10px',
      width: '180px'
    },
    filterFormValueInput: {
      width: '180px'
    },
    menu: {
      '& .MuiDataGrid-menuList': {
        width: '180px',
        marginTop: '10px',
        '& .MuiMenuItem-root': {
          padding: '12px 16px'
        },
        '& .MuiListItemIcon-root': {
          color: palette.shades[700]
        },
        '& .MuiListItemText-primary': {
          fontFamily: palette.fontFamilies.poppins,
          fontSize: '13px',
          lineHeight: '16px',
          fontWeight: '600'
        }
      }
    },
    menuIcon: {
      width: 'initial',
      marginRight: 'initial'
    },
    menuIconButton: {
      opacity: '1',
      borderRadius: '0',
      border: 'none',
      padding: '0',
      position: 'absolute',
      bottom: '10px',
      left: '0',
      right: '0',
      top: '10px',
      '& .MuiSvgIcon-root': {
        display: 'none'
      },
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    iconButtonContainer: {
      display: 'none'
    },
    columnSeparator: {
      display: 'none'
    },
    columnHeaders: {
      lineHeight: 'initial !important',
      overflow: 'visible',
      zIndex: '10'
    },
    columnHeader: {
      padding: '0 5px',
      lineHeight: 'initial',
      position: 'relative',
      transition: "background-color ".concat(palette.transitions.short),
      '& .inline-arrow': {
        display: 'inline-block',
        transform: 'rotate(-180deg)'
      },
      '&[aria-sort="none"]': {
        '& .inline-arrow': {
          display: 'none'
        }
      },
      '&[aria-sort="ascending"]': {
        '& .inline-arrow': {
          display: 'inline-block'
        }
      },
      '&[aria-sort="descending"]': {
        '& .inline-arrow': {
          display: 'inline-block',
          transform: 'rotate(0deg)'
        }
      },
      '&:hover': {
        '& .MuiDataGrid-columnHeaderDraggableContainer': {
          backgroundColor: palette.shades[300]
        },
        '& .MuiButton-actionIcon': {
          border: "1px solid ".concat(palette.shades[300])
        }
      },
      '&:focus': {
        outline: 'none'
      },
      '&:focus-within': {
        outline: 'none'
      },
      '&:last-child': {
        paddingRight: '22px'
      },
      '&:nth-of-type(1)': {
        paddingLeft: '22px'
      },
      '&--filtered': {
        '& .MuiDataGrid-columnHeaderTitleContainerContent .inline-filter': {
          display: 'inline-block'
        }
      }
    },
    columnHeaderTitle: {
      fontWeight: '600',
      fontSize: '13px',
      lineHeight: '18px'
    },
    columnHeaderTitleContainer: {
      fontWeight: '600',
      fontSize: '13px',
      lineHeight: '18px',
      overflow: 'visible',
      minWidth: '36px'
    },
    columnHeaderDraggableContainer: {
      alignItems: 'center'
    },
    columnHeadersInner: {
      alignItems: 'stretch'
    },
    cell: {
      padding: '20px 5px',
      '&:focus': {
        outline: 'none'
      },
      '&:focus-within': {
        outline: 'none'
      },
      '&--textRight': {
        textAlign: 'right',
        '& .cellContent': {
          justifyContent: 'flex-end',
          display: 'flex'
        }
      },
      '&:first-of-type': {
        paddingLeft: '22px'
      },
      '&:last-of-type': {
        paddingRight: '22px'
      },
      '& .cellContent': {
        padding: '10px',
        width: '100%'
      }
    },
    row: {
      position: 'relative',
      transition: "all ".concat(palette.transitions.short),
      '& .MuiButton-actionButton': {
        border: "1px solid transparent",
        height: '36px'
      },
      '&:hover': {
        backgroundColor: palette.shades[200],
        '& .MuiButton-actionIcon': {
          border: "1px solid ".concat(palette.shades[300]),
          backgroundColor: palette.shades[200],
          '&:hover': {
            backgroundColor: palette.shades[300]
          }
        },
        '& .MuiButton-actionButton': {
          border: "1px solid ".concat(palette.shades[300])
        },
        '& .MuiChip-portal': {
          border: "1px solid ".concat(palette.shades[300])
        }
      },
      '&.Mui-selected': {
        backgroundColor: palette.success.light,
        '&:hover': {
          backgroundColor: palette.success.light
        }
      }
    },
    columnHeaderCheckbox: {
      '& .MuiDataGrid-columnHeaderTitleContainerContent': {
        overflow: 'visible'
      },
      '&:hover': {
        '& .MuiDataGrid-columnHeaderDraggableContainer': {
          backgroundColor: palette.shades[100]
        }
      }
    }
  }
};
export default MuiDataGrid;